import { render, staticRenderFns } from "./AdminPolicyDelete.vue?vue&type=template&id=2f18edb0&scoped=true"
import script from "./AdminPolicyDelete.vue?vue&type=script&lang=js"
export * from "./AdminPolicyDelete.vue?vue&type=script&lang=js"
import style0 from "./AdminPolicyDelete.vue?vue&type=style&index=0&id=2f18edb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f18edb0",
  null
  
)

export default component.exports